import { Component, OnInit } from '@angular/core';
import { Sidebar } from 'src/app/shared';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  constructor(public _sidebar: Sidebar) { }

  ngOnInit() {
    window.scroll(0, 0);
  }

}
